import React from "react";
import { Route, Routes } from "react-router-dom";

import './App.css';
import {Config} from "./types";
import {PasskeyEnrollRoute} from "./components/passkey/passkey-enroll";
import Success from "./components/Success";

function App(config: Config) {
  // IDAPI-2112: the "/email-enroll" route (self-service email MFA enrollment)
  // has been removed - email is no longer an enrollable MFA method.
  const routes = <Routes>
    <Route path="/passkey/enroll" element={<PasskeyEnrollRoute {...config} />} />
    <Route path="/success" element={<Success />} />
    <Route path="/cancel" element={<>enrollment cancelled.</>} />
    <Route path="/error" element={<>Error!</>} />
    <Route path="/*" element={<>404 Not found!</>} />
  </Routes>
  return (<div id="app" className="d-flex flex-column h-100">
    <Routes>
      <Route path="/my/*" element={routes} />
      <Route path="/*" element={routes} />
    </Routes>
    </div>);
}

export default App;
